exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PrintedUnclosed{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/printed-unclosed/printed-unclosed.scss
// module id = 1325
// module chunks = 0